import Questions from 'modules/acount/questions';
import Header from 'modules/header/farm/main';

const QuestionsPage = () => {
  return (
    <>
      <Header title="سوالات متداول" />
      <div className=" mt-6">
        <Questions />
      </div>
    </>
  );
};

export default QuestionsPage;
